import { Injectable } from '@angular/core';
import { AuthenticateService } from '../fi-services/authenticate.service';
import { FiCountdownNotificationService } from '../notification/countdown-notification/countdown-notification.service';
import { FiInactivityCountdownNotificationComponent } from './inactivity-countdown-notification.component';
import { AppTextService } from '@fi-shared/app-text';
import { FiCustomerDataService } from '@fi-shared/fi-shared-services/fi-customer-data.service';
import { FiAppSettings } from '@fi-shared/fi-app-settings';
import { FiAuthenticateSharedService } from '@fi-shared/fi-auth-shared/fi-authenticate-shared.service';

@Injectable()
export class FiInactivityCountdownNotificationService {
    result = {};
    timer = null;
    currentCountDown = null;
    Reset: () => void;

    constructor(
        private authenticateService: AuthenticateService,
        private appTextService: AppTextService,
        private countdownNotificationService: FiCountdownNotificationService,
        private customerDataService: FiCustomerDataService,
        private authenticateSharedService: FiAuthenticateSharedService,
    ) {}

    StartTimer() {
        this.timer = setTimeout(
            () => {
                const params: ICountdownNotificationParams = {
                    countDownTime: FiAppSettings.InactivityCountDownNotificationTime,
                    countDownTitle: this.appTextService.get('inactivity.logout_countdown'),
                    countDownText: this.appTextService.get('inactivity.stay_logged_warning'),
                    cssClass: '',
                    refreshSession: () => {
                        this.ResetTimer();
                        this.authenticateService.RefreshSession();
                    },
                };
                const noti = (this.currentCountDown = this.countdownNotificationService.StartCountDown(
                    params,
                    FiInactivityCountdownNotificationComponent,
                ));
                noti.countdownFinished.subscribe(() => {
                    this.authenticateSharedService.logout();
                });
            },
            this.customerDataService.customerData.SessionExpire * 60 * 1000 -
                FiAppSettings.InactivityCountDownNotificationTime,
        );
    }

    StopTimer() {
        if (this.timer) {
            clearTimeout(this.timer);
            this.timer = null;
        }

        if (this.currentCountDown) {
            this.currentCountDown.HideNotification();
        }
    }

    ResetTimer() {
        this.StopTimer();
        this.StartTimer();
    }
}
